import clsx from 'clsx';
import { View } from 'react-native';
import { Typography } from '../../Core/Typography/Typography';
import { CheckmarkIcon } from '../../Icons/CheckmarkIcon';
import { cn } from '../../lib/utils';

export type Step = {
  title: string;
  subtitle: string;
  state: 'complete' | 'pending';
};

interface TimelineProps {
  className?: string;
  steps: Step[];
}

export const Timeline = ({ className, steps }: TimelineProps) => {
  return (
    <View className={cn('flex-col justify-start', className)}>
      {steps.map((step, index) => (
        <>
          <View
            key={index}
            className="flex-row items-center justify-left gap-4">
            <View
              className={'flex-col items-center justify-center flex gap-2 w-6'}>
              <View
                className={clsx(
                  'w-6 h-6 rounded-full justify-center items-center flex',
                  step.state === 'complete'
                    ? 'bg-white'
                    : 'w-4 h-4 bg-[#4A53FC]',
                )}>
                {step.state === 'complete' && (
                  <CheckmarkIcon stroke="#626AFF" style={{ width: 12 }} />
                )}
              </View>
            </View>
            <View className={'flex-col items-start justify-left'}>
              <Typography
                size="large"
                weight="medium"
                variant="body"
                className="text-white">
                {step.title}
              </Typography>
              <Typography
                size="small"
                variant="body"
                weight="regular"
                className="text-white">
                {step.subtitle}
              </Typography>
            </View>
          </View>
          {index !== steps.length - 1 && (
            <View
              className={clsx(
                'w-[1px] h-[40px] bg-white ml-3',
                index === steps.length - 1 && 'hidden',
              )}
            />
          )}
        </>
      ))}
    </View>
  );
};
